// 主题: 模板
export const TEMPLATE_MAP = {
  sport789: 'template789',
  black: 'black',
  blue: 'blue',
  phlwin: 'templatePhlwin',
  bigwin: 'templatePhlwin',
  bigwinApp: 'templateBigwin',
  ak8: 'templateAK8',
  svbet: 'templateSvbet',
  SHIWAN_haxi: 'SHIWAN_haxi',
};
